<template>
  <v-card :key="paper.id"
          elevation="1"  
          rounded
          class="mb-2 pa-1"           
  >  
    <v-row v-for="(ret, idx) in paper.returns"
           :key="ret.id" 
           dense class="ma-1 border"
    >
      <template v-if="$vuetify.breakpoint.mdAndUp">
        <v-col cols="2" class="text-uppercase font-weight-bold align-self-center">
          {{ paper.title }}
        </v-col>
        <v-col cols="3" class="text-uppercase font-weight-bold align-self-center">
          <template v-if="paper.type === 1">
            {{ paper.edition }}
          </template>
          <div v-if="paper.description" class="v-messages">
            {{ paper.description }}
          </div>
        </v-col>
        <v-col cols="1" class="align-self-center">
          {{ paper.deliveryDate|longPaperDate }} 
        </v-col>
        <v-spacer v-if="$vuetify.breakpoint.mdAndUp" />
        <v-col cols="1" :offset="isReportStateRetur ?'1':''">
          <v-text-field v-model.number="ret.bundleId"
                        label="Bunt"
                        type="number"
                        :disabled="bundleDisabled(ret)"
                        dense
                        hide-details="auto"                        
                        outlined
                        class="input"                        
                        @focus="focus($event,ret)"
                        @change="changed($event,ret)"                            
          />                                  
        </v-col>
        <v-col cols="1" class="">
          <v-text-field v-model.number="ret.amount"
                        type="number"
                        :disabled="readonly(ret)"
                        hide-details="auto"
                        class="input"
                        outlined                            
                        dense                      
                        validate-on-blur    
                        :rules="[rules.validrange(ret), rules.morethandelivered(ret)]"
                        :hint="'Levererat antal: '+paper.deliveredAmount"                       
          >
            <template v-slot:label>
              <div>
                Antal
              </div>
            </template>
          </v-text-field>                                  
        </v-col>
        <v-col :cols="isReportStateRetur?'2':'3'">
          <v-btn class="mt-1 red darken-3"
                 hide-details="auto"                 
                 dense
                 dark                 
                 @click="split(ret,idx)"                   
          >
            {{ buttonLabel }}
          </v-btn>
            
          <v-btn v-if="ret.split" label="Ångra" class="mt-1 ml-1 grey"
                 hide-details="auto"                 
                 dense
                 dark
                 @click="remove(ret,idx)"                   
          >       
            Ångra
          </v-btn>                  
        </v-col>
      </template>
      <template v-else>
        <v-container>
          <v-row dense>
            <v-col cols="9" justify="end" class="text-uppercase font-weight-bold align-self-center">
              {{ paper.title }} <template v-if="paper.type === 1">
                {{ paper.edition }}
              </template>
              <div v-if="paper.description" class="v-messages">
                {{ paper.description }}
              </div>
            </v-col>
            <v-col cols="3" class="font-weight-bold align-self-center">
              {{ paper.deliveryDate|longPaperDate }} 
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="3">
              <v-text-field v-model.number="ret.bundleId"
                            label="Bunt"
                            type="number"
                            :disabled="bundleDisabled(ret)"
                            dense
                            hide-details="auto"
                            outlined                            
                            @focus="focus($event,ret)"
                            @change="changed($event,ret)"                            
              />                                  
            </v-col>
            <v-col cols="3">
              <v-text-field v-model.number="ret.amount"
                            type="number"
                            :disabled="readonly(ret)"
                            hide-details="auto"
                            outlined                            
                            dense                    
                            validate-on-blur                              
                            :rules="[rules.validrange(ret), rules.morethandelivered(ret)]"
                            :hint="'Levererat antal: '+paper.deliveredAmount"                            
              >
                <template v-slot:label>
                  <div>
                    Antal
                  </div>
                </template>
              </v-text-field>                                  
            </v-col>
            <v-spacer />
            <v-col cols="3">
              <!-- <v-btn label="Ny bunt" class="mt-1"
                     hide-details="auto"
                     outlined
                     dense
                     color="error"   
                     @click="split(ret,idx)"                   
              > 
                <span v-if="reportState == 1">Ny bunt</span>
                <span v-else>Tilläggsrapportera</span>              
              </v-btn>   -->
              <v-menu                
                bottom
                left
                origin="center right"
                transition="scale-transition"
              >
                <template v-slot:activator="{ on }">
                  <v-btn color="default" class="ml-0 mr-0" icon large v-on="on">
                    <v-icon>mdi-dots-horizontal</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="split(ret, idx)">
                    {{ buttonLabel }}         
                  </v-list-item>
                  <v-list-item :disabled="!ret.split" @click="remove(ret,idx)">
                    Ångra
                  </v-list-item>
                  <v-list-item v-show="reportState == 1" @click="setNoReturns(ret)">
                    Slutsåld
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-col>
          </v-row>     
        </v-container>   
      </template>
    </v-row>             

    <v-row class="text-center red--text">
      <v-col v-if="paper.hasError">                                                   
        {{ paper.error }}                
      </v-col>     
    </v-row>
  </v-card>              
</template>

<script>
import log from '@/logger'
import { mapState, mapMutations } from 'vuex'
import { clone } from 'lodash'
import {
  APP_OPEN_BUNDLES,
  APP_LAST_SELECTED_BUNDLE_ID
} from '@/store/appStates'
import { SET_LAST_SELECTED_BUNDLE_ID } from '@/store/appMutations'

export default {
  name: 'Paper', 
   props: {
    paper: {
      type: Object,
      required: true,
    },
    reportState: { type: Number, required: true },
    isReportStateRetur : { type:Boolean, required:true}    
  },     
  data(){
    return{
      rules:{
        validrange(item){
          if(item.amount !== undefined && (item.amount >= '0' && item.amount <='999')){
            if(item.bundleId){
              return true
            }
            else{            
              return 'Ange buntnr.'
            }
          }
          else if((item.bundleId === undefined || item.bundleId === '') && 
             (item.amount === undefined || item.amount === '')){
            return true
          }
          else if((item.bundleId !== undefined || item.bundleId !== '') &&
                  (item.amount === undefined || item.amount === '')){
            return 'Ange antal.'
          }
          if((item.bundleId === undefined || item.bundleId === '') && 
             (item.amount === undefined || item.amount === '')){
            return true
          }
          return 'Orimligt värde har angetts.'
        },      
        morethandelivered(item){
          if(item.isOpen === false){
            return true
          }
          if((item.bundleId === undefined || item.bundleId === '') && 
             (item.amount === undefined || item.amount === ''))
            {
              return true
            }
         return value => ( value <= item.deliveredAmount || item.deliveredAmount === undefined )|| 'Kan inte vara större än antal levererat.'
        }
      }
    }
  }, 
  computed: {
    ...mapState({
      theBundles: state => state[APP_OPEN_BUNDLES],
      lastBundleId: state => state[APP_LAST_SELECTED_BUNDLE_ID]
    }),
    buttonLabel(){
      return (this.reportState === 1)?'Ny bunt':'Tilläggsrapportera'
    }   
  },
  
  methods: {
    ...mapMutations({
      setLastBundleId: SET_LAST_SELECTED_BUNDLE_ID
    }),
    setNoReturns(ret) {
      log.debug('Set no returns on:', ret)
      this.$set(ret, 'amount', 0)
      this.setBundle(ret)
    },
    setBundle(paper) {
      if(paper.split === undefined || (paper.split === true && this.reportState === 2)){
        if (
          !paper.bundleId &&
          this.theBundles[paper.type] &&
          this.theBundles[paper.type].length > 0
        ) {
          let bundleId = this.lastBundleId[paper.type]
          if (bundleId !== undefined && bundleId instanceof Object == false) {
            this.$set(paper, 'bundleId', bundleId)
          } else {
            this.$set(
              paper,
              'bundleId',
              this.theBundles[paper.type][this.theBundles[paper.type].length - 1].id
            )
          }
        } else {
          let bundleId = this.lastBundleId[paper.type]
          if (bundleId !== undefined && bundleId instanceof Object == false) {
            this.$set(paper, 'bundleId', bundleId)
          }
        }
      }
    },
    bundleDisabled(paper){
      if(this.reportState === 2 && paper.split === undefined){

        return true
      }
      
      if (paper.isOpen === undefined) {
        return false
      } else {
        return !paper.isOpen
      }
    },
    readonly(paper) {
     
      if (paper.isOpen === undefined) {
        return false
      } else {
        return !paper.isOpen
      }
    },
    blur(item) {
      log.debug('Blur', item)
    },
    focus(event, retur) {
      log.debug('Focus', event)
      this.setBundle(retur)
    },
    changed(value, retur) {
      log.debug('Changed', value)
      let paperType = retur.type
      this.setLastBundleId({ bundleId: value, paperType })          
    },
    split(retur, idx) {
      var copy = clone(retur)
      if ('amount' in copy) delete copy.amount
      if ('bundleId' in copy) copy.bundleId = undefined
      copy.isOpen = true
      
      copy.deliveredAmount = retur.deliveredAmount - retur.amount
           
      copy.id = `${copy.id}-${idx++}`
      copy.split = true
      this.paper.returns.push(copy)
    },
    remove(retur) {      
      this.paper.returns.splice(this.paper.returns.findIndex(v => v.id === retur.id), 1)      
    }
  }
}
</script>

<style scoped>
.input >>> input[type="number"] {
  -moz-appearance: textfield;
}
.input >>> input::-webkit-outer-spin-button,
.input >>> input::-webkit-inner-spin-button {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}
</style>